import { makeServerRequest } from '../../store/actions/util';
const apiPrefix = "api/v1";

export function findCountryCustomerBranchesSuccess(countryCustomerBranches) {
    return {
        type: "SEARCH_COUNTRY_CUSTOMER_BRANCHES_SUCCESS",
        payload: countryCustomerBranches
    };
}

export function findCountryCustomerBranchesFailure(error) {
    return {
        type: "SEARCH_COUNTRY_CUSTOMER_BRANCHES_FAILURE",
        payload: error
    };
}

export const findCountryCustomerBranches = (key, group, includeCountry) => {
    return (dispatch) => {
        dispatch({type: "SEARCH_COUNTRY_CUSTOMER_BRANCHES", payload: key, group, includeCountry});

        return makeServerRequest(apiPrefix + "/listCountryCustomerBranches?name=" + key + "&group=" + group + "&includeCountries=" + includeCountry).then(
            response => dispatch(findCountryCustomerBranchesSuccess(response.data))
        ).catch(
            error => dispatch(findCountryCustomerBranchesFailure(error))
        );
    };
};

export const resetCountryCustomerBranchesSearch = () => {
    return (dispatch) => {
        dispatch({type: "RESET_SEARCH_COUNTRY_CUSTOMER_BRANCHES", payload: ""});
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/branchSearch.js